import { ENDPOINTS } from "../../utils/endPoints";
import {
  DELETE_API_CALL,
  GET_API_CALL,
  PATCH_API_CALL,
  POST_API_CALL,
  POST_API_FILE_UPLOAD_CALL,
  PUT_API_CALL,
} from "../../utils/services";
import {
  UPDATE_SITES_LIST,
  UPDATE_SITES_LOADING,
} from "../../store/actionTypes";
import { createParams } from "../../utils/commonFunctions";
import toast from "react-hot-toast";

export const getSitesList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_SITES_LOADING });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().SiteReducer;
    const params = createParams({
      pageNo,
      limit,
      searchKey,
      sortOrder,
      sortBy,
    });
    GET_API_CALL(ENDPOINTS.SITES.SITES_LIST, params, (response) => {
      console.log("Response :", response);
      if (response.isSuccess) {
        let { data, total } = response?.data;
        let totalPages = Math.ceil(total / limit);
        dispatch({
          type: UPDATE_SITES_LIST,
          payload: {
            sitesList: data,
            total,
            totalPage: totalPages,
          },
        });
      }
      dispatch({ type: UPDATE_SITES_LOADING });
    });
  };
};

export const addSite = (data, callback) => {
  const toastId = toast.loading("Adding Site");
  return () => {
    POST_API_CALL(ENDPOINTS.SITES.ADD_SITE, data, (response) => {
      console.log("Add Sites Response :", response);
      if (response.isSuccess) {
        toast.success(response.data.message);
      }
      toast.dismiss(toastId);
      callback(response);
    });
  };
};

export const updateSite = (siteId, data, callback) => {
  const toastId = toast.loading("Updating Site");
  return () => {
    PUT_API_CALL(
      ENDPOINTS.SITES.SITE_DETAIL + `?siteId=${siteId}`,
      data,
      (response) => {
        console.log("Update site Response :", response);
        if (response.isSuccess) {
          toast.success(response.data.message);
          callback(response);
        }
        callback(response);
        toast.dismiss(toastId);
      }
    );
  };
};

export const uploadSiteImage = (data, callback) => {
  return () => {
    POST_API_CALL(ENDPOINTS.SITES.UPLOAD_IMAGE, data, (response) => {
      console.log("Upload Image First Response :", response);
      if (response.isSuccess) {
        callback(response);
      } else {
        callback({...response,isSuccess:false});
      }
    });
  };
};
// working
export const uploadFileToS3 = (files, s3Datas, callback) => {
  return () => {
    const formData = new FormData();
    for (const key in s3Datas?.fields) {
      formData.append(key, s3Datas?.fields[key]);
    }
    formData.append("file", files);
    console.log('s3 data :',s3Datas);
    POST_API_FILE_UPLOAD_CALL(s3Datas.url, formData, (response) => {
      console.log("UploadFileToS3 Second Response :", response);
      if (response.isSuccess) {
        callback({ ...response, imageUrl: s3Datas.url + s3Datas.fields?.key });
      } else {
        callback(response);
      }
    });
  };
};

export const siteDetail = (params, callback) => {
  return () => {
    GET_API_CALL(ENDPOINTS.SITES.SITE_DETAIL, params, (response) => {
      console.log("SITE DETAIL RESPONSE :", response);
      if (response.isSuccess) {
        callback(response.data);
      }
    });
  };
};

export const siteActiveInactive = (data, params, callback) => {
  return () => {
    const toastId = toast.loading("Updating");
    PATCH_API_CALL(ENDPOINTS.SITES.UPDATE_STATUS + params, data, (response) => {
      console.log("SiteActiveInactive Response :", response);
      if (response.isSuccess) {
        callback(response);
        toast.success(response.data?.message);
      }
      toast.dismiss(toastId);
    });
  };
};

export const fileDeleteHandler = (key, callback) => {
  return () => {
    DELETE_API_CALL(ENDPOINTS.COMMON.DELETE_FILE + `${key}`, (response) => {
      console.log("Delete File Response :", response);
      callback(response);
    });
  };
};
